module.exports = __webpack_public_path__ + "img/aeroland-payment-hero-bg.c31d4ad5.jpg";